import config from '#core/config';
import load from '#core/load';
import cookie from '#core/cookie';
import util from '#core/util';
import hash from '#common/hash';

// TODO: eventually this should be refactored to use most of the same code as
// the alert, or vice versa

const cookie_prefix = 'modal_shown';
const cookie_value = '1';
const id_attr = 'id';
const click_delay_attr = 'data-modal-click-delay';
const page_delay_attr = 'data-modal-page-delay';
const days_attr = 'data-modal-days';
const idle_attr = 'data-modal-idle';
const is_active_attr = 'data-is-active';
const modal_$ = '[uk-modal]';
const true_s = 'true';
const false_s = 'false';

const before_show_e = 'beforeshow'; // Before item is shown
const show_e = 'show'; // After item is shown
const shown_e = 'shown'; // After item's show animation has completed
const before_hide_e = 'beforehide'; // Before item is hidden
const hide_e = 'hide'; // After item's hide animation has started
const hidden_e = 'hidden'; // After item is hidden

let has_modal = false;
let user_has_interacted = false;
let $all_modals = null;


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('modal')) return false;
		
		load.content(() => {
			hash.setLinkAttribute(modal_$, false);
			has_modal = assign_elements();
			if (!has_modal) return false;
		});
		load.all(() => {
			has_modal = assign_elements();
			if (!has_modal) return false;
			
			start();
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_modal) return true;
	
	// TODO: do not store objects on load, account for dynamic content
	$all_modals = document.querySelectorAll(modal_$);
	if (!$all_modals.length) return false;
	
	$all_modals.forEach($modal => {
		$modal.addEventListener(before_show_e, e => {
			activate($modal);
		});
		$modal.addEventListener(hidden_e, e => {
			deactivate($modal);
		});
	});
	
	['mousedown', 'touchstart'].forEach(event_type => {
		document.addEventListener(event_type, function click_listener(e) {
			user_has_interacted = true;
			document.removeEventListener(event_type, click_listener);
		});
	});
	
	return true;
}


/**
 * Start countdown to showing modal
 */
function start() {
	$all_modals.forEach($modal => {
		if (!$modal.hasAttribute(page_delay_attr)) return false;
		
		const delay = parseFloat($modal.getAttribute(page_delay_attr)) || 0;
		setTimeout(() => {
			show_on_timer($modal);
		}, parseInt(delay * 1000));
	});
	
	setTimeout(() => {
		activate_from_url();
	}, 250);
}


/**
 * Show modal automatically after delay
 * @param {element} $modal
 */
function show_on_timer($modal) {
	const modal_id = $modal.getAttribute(id_attr);
	const cookie_name = get_cookie_name(modal_id);
	const days_between_showing = parseInt($modal.getAttribute(days_attr)) || 0;
	const show_only_when_idle = $modal.hasAttribute(idle_attr);
	const force_cookie = util.get_query('modal');
	
	if (
		(
			has_cookie(cookie_name)
			&& force_cookie != 'true'
		) || (
			show_only_when_idle
			&& user_has_interacted
		)
	) return false;
	
	show($modal);
	cookie.create(cookie_name, cookie_value, days_between_showing);
}


/**
 * Check URL for target modal and activate
 */
function activate_from_url() {
	const url_hash = window.location.hash.substring(1);
	if (!url_hash.length) return false;
	
	const $modal = document.querySelector(`#${url_hash}${modal_$}`);
	if (!$modal) return false;
	
	// Remove modal ID from URL
	history.replaceState(null, null, '#');
	
	show($modal);
}


/**
 * Show modal
 * @param {element} $modal
 */
function show($modal) {
	const delay = $modal.getAttribute(click_delay_attr) || 0;
	setTimeout(() => {
		UIkit.modal(`#${$modal.id}`).show();
	}, delay * 1000);
}


/**
 * Activate modal before showing
 * @param {element} $modal
 */
function activate($modal) {
	$modal.setAttribute(is_active_attr, true_s);
}


/**
 * Deactivate modal after hiding
 * @param {element} $modal
 */
function deactivate($modal) {
	$modal.setAttribute(is_active_attr, false_s);
}


/**
 * Evaluate cookie to determine if modal should be shown
 * @param {string} cookie_name
 * @return {boolean}
 */
function has_cookie(cookie_name) {
	const modal_cookie = cookie.read(cookie_name);
	return modal_cookie === cookie_value;
}


/**
 * Get cookie name
 * @param {string} id
 * @return {string}
 */
function get_cookie_name(id) {
	return util.snake(`${config.site_name}_${cookie_prefix}_${id}`);
}
